import { render, staticRenderFns } from "./tempTukarLantik.vue?vue&type=template&id=1b3d35fb&"
import script from "./tempTukarLantik.vue?vue&type=script&lang=js&"
export * from "./tempTukarLantik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports